module.exports = __webpack_public_path__ + "img/CR_oceanShippingbanner.e9e0858f.jpg";